



























import { Component, Prop, Vue } from "vue-property-decorator";
import { RiskLevel } from "@/model/RiskLevel";
import { RiskLevelForScore } from "@/model/Model";

@Component
export default class DrinkDrivingAdvice extends Vue {
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;
  @Prop() public score!: number;

  private showContent: boolean = false;

  private toggleContent() {
    this.showContent = !this.showContent;
  }

  private get isLowerRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Lower;
  }
}
